import { render, staticRenderFns } from "./upgradePlugin.vue?vue&type=template&id=524b6d00&scoped=true&"
import script from "./upgradePlugin.vue?vue&type=script&lang=js&"
export * from "./upgradePlugin.vue?vue&type=script&lang=js&"
import style0 from "./upgradePlugin.vue?vue&type=style&index=0&id=524b6d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b6d00",
  null
  
)

export default component.exports